<template>
    <div id="help" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="HelpDocument">WorkFlow Document:</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content help-page">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" id="importFile" class="addinspectionForm basic-form-container">
                                <h4>Click on the document to download.</h4>
                                <template v-if="moduleArr && moduleArr.length > 0">
                                    <div class="p-4">
                                        <template v-for="(file,fkey) in moduleArr">
                                            <a :key="fkey" href="javascript:void(0)" class="d-block mb-2 color-blue" v-on:click="downloadDoc(file.path)">&#9642; &nbsp;{{file.name}}</a>
                                        </template>
                                    </div>
                                </template>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
    name: "Help",

    mixins:[commonMixins,contractMixins],
    data: () => ({
        loading:false,
        permissions: [],
        cantAccessPage: "",
        moduleArr: [],
        error: "",
    }),
    watch:{

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {

                    self.cantAccessPage = true;
                }

            },
    },
    created: function() {

    },
    mounted: function() {
            var self = this;
            self.getPermissions();
            self.getHelpDoc();
    },
    methods: {
        downloadDoc(docPath){
            var self = this;
            var save = document.createElement('a');
            save.href = docPath;
            save.download = docPath;
            save.target = '_blank';
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
        },

        getHelpDoc() {
            var self = this;
            self.loading = true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/get-document",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.moduleArr = data.content;
                    console.log(self.moduleArr.length);
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Help.vue